module.exports = __webpack_public_path__ + "img/Mask-group.7b568ac3.svg";